var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFileCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9977 1.99951H5.99958C5.46925 1.99951 4.96065 2.21018 4.58566 2.58517C4.21067 2.96017 4 3.46877 4 3.99909V19.9957C4 20.526 4.21067 21.0346 4.58566 21.4096C4.96065 21.7846 5.46925 21.9953 5.99958 21.9953H17.997C18.5273 21.9953 19.0359 21.7846 19.4109 21.4096C19.7859 21.0346 19.9966 20.526 19.9966 19.9957V6.99845L14.9977 1.99951Z",
    stroke: "#12BC61",
    strokeWidth: 1.99958,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9961 1.99951V5.99866C13.9961 6.52898 14.2068 7.03758 14.5818 7.41257C14.9567 7.78757 15.4653 7.99824 15.9957 7.99824H19.9948",
    stroke: "#12BC61",
    strokeWidth: 1.99958,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.99805 14.9966L10.9976 16.9962L14.9968 12.9971",
    stroke: "#12BC61",
    strokeWidth: 1.99958,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileCheck);
export default __webpack_public_path__ + "static/media/icon_FileCheck.c1c2932047abb6e85109c53434a546d9.svg";
export { ForwardRef as ReactComponent };